export const CONSTANT = {
  LOCAL_STORAGE_LANG_KEY: 'BA_LANG_KEY',
  LANGUAGES: [
    { key: 'en', name: 'english' },
    { key: 'fr', name: 'french' },
  ],
};
export const DEBUG = true;
